import {retry} from '@rambler-id/promise'

export const afisha = retry<any>(() => import('./afisha'))
export const afishaBlue = retry<any>(() => import('./afisha-blue'))
export const afishaRed = retry<any>(() => import('./afisha-red'))
export const afishaRestaurants = retry<any>(
  () => import('./afisha-restaurants')
)
export const championat = retry<any>(() => import('./championat'))
export const championatMma = retry<any>(() => import('./championat/mma'))
export const championatEpl = retry<any>(() => import('./championat/epl'))
export const championatVertical = retry<any>(
  () => import('./championat-vertical')
)
export const classic = retry<any>(() => import('./classic'))
export const eda = retry<any>(() => import('./eda'))
export const lenta = retry<any>(() => import('./lenta'))
export const lentaEpl = retry<any>(() => import('./lenta/epl'))
export const rambler = retry<any>(() => import('./rambler'))
export const ramblerEpl = retry<any>(() => import('./rambler/epl'))
export const unity = retry<any>(() => import('./unity'))
export const unityMma = retry<any>(() => import('./unity/mma'))
export const unityEpl = retry<any>(() => import('./unity/epl'))
export const ramblerVideo = retry<any>(() => import('./rambler-video'))
export const ramblerVideoPurple = retry<any>(
  () => import('./rambler-video-purple')
)
export const universal = retry<any>(() => import('./universal'))

// map skin names to eagle values
export {
  afisha as afisha_html5,
  afishaBlue as afisha_html5_blue,
  afishaRestaurants as afisha_restaurants,
  championat as championat_html5,
  championatMma as championat_html5_mma,
  championatEpl as championat_epl,
  championatVertical as championat_vertical,
  unityMma as unity_mma,
  unityEpl as unity_epl,
  eda as eda_html5,
  lentaEpl as lenta_epl,
  rambler as rambler_2018,
  ramblerEpl as rambler_new_epl,
  ramblerVideoPurple as classic_html5,
  ramblerVideoPurple as rambler_html5,
  classic as html5_classic
}
